import {
    SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED,
    SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST
} from './all-classes-actions';

const initialState = {
    isLoading: false,
    data: null
};

/**
 * Skill Quests Mastery - All Classes Reducer
 *
 * Consumes SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST: {
            return {
                ...state,
                isLoading: true,
                data: null
            };
        }
        case SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED:
            return {
                ...state,
                isLoading: false,
                data: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/all-classes/all-classes-reducer.js